const handleDatePickerErrorMessage = {
  sendToMaintenanceDateError: 'Select a date after Send to maintenance date',
  returnFromMaintenanceDateError: 'Select a date after Return from maintenance date',
};

export default handleDatePickerErrorMessage;